import {Component, OnInit, ChangeDetectorRef} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiService} from '../../../services/api.service';
import {SystemAttributesValue} from '../../../model/systemAttributesValue';
import {SysAttrWrapper} from '../../../model/sysAttrWrapper';
import {Constants} from '../../../constants/ebtq-constants';
import {ErrorService} from '../../../shared/error-page/service/error-service';
import {UserDetailsModel} from '../../../constants/userModel';
import {Title} from '@angular/platform-browser';

@Component({
  standalone: false,
  selector: 'app-update-system-attributes',
  templateUrl: './update-system-attributes.component.html',
  styleUrls: ['./update-system-attributes.component.scss']
})
export class UpdateSystemAttributesComponent implements OnInit {
  sysAttr: any[];
  selectedAttr: string;
  selectedAttrLabel: string;
  loader = false;
  attrName: string;
  attrVal: string;
  flagName: string;
  flagVal: any[];
  selectedFlag: string;
  successMess: boolean;
  showErrorDiv: boolean;
  errHeading: string;
  errMessage: string;
  containsError = false;
  errorMsg: string;
  errMessage2:string;
  userDetails: UserDetailsModel;
  title = 'Update System Attributes';

  constructor(private httpService: HttpClient, private apiService: ApiService, private errorService: ErrorService,
              private titleService: Title, private cdr: ChangeDetectorRef) {

    this.sysAttr = [];
    this.sysAttr.push({label: Constants.SYS_ATTR_SYSBANNER, value: Constants.SYS_ATTR_SYSBANNER});
    this.sysAttr.push({label: Constants.SYS_ATTR_SRVCBANNER, value: Constants.SYS_ATTR_SRVCBANNER});
    this.sysAttr.push({label: Constants.SYS_ATTR_REVMORTBANNER, value: Constants.SYS_ATTR_REVMORTBANNER});
    this.sysAttr.push({label: Constants.SYS_ATTR_DELIVBANNER, value: Constants.SYS_ATTR_DELIVBANNER});
    this.selectedAttr = this.sysAttr[0].value;
    this.selectedAttrLabel = this.sysAttr[0].label;
    this.attrName = '';
    this.attrVal = '';
    this.flagName = '';
    this.successMess = false;
    this.showErrorDiv = false;
    this.errHeading = Constants.ERR_HEADER;
    this.errMessage = Constants.ATTR_VAL_EMPTY_MESS;
    this.errMessage2 = Constants.ATTR_VAL_LENGTH_EXCEED;
  }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
  }

  getSystemAttr() {
    this.flagVal = [];
    this.flagVal.push({label: 'true', value: 'true'});
    this.flagVal.push({label: 'false', value: 'false'});
    this.loader = true;
    let resultMap: { [key: string]: any; };
    this.showErrorDiv = false;
    this.successMess = false;
    this.apiService.getSystemAttr(this.selectedAttr + ' Available')
      .subscribe(
        (data: any) => {
          resultMap = data.sysAttrMap;
          this.attrName = this.selectedAttr;
          this.flagName = this.selectedAttr + ' Available';
          if (this.selectedAttr === Constants.SYS_ATTR_SYSBANNER) {
            this.selectedFlag = resultMap.isSystemBannerMsgAvailable;
            this.attrVal = resultMap.systemAvailabilityMessage;
          } else if (this.selectedAttr === Constants.SYS_ATTR_SRVCBANNER) {
            this.selectedFlag = resultMap.isServicingBannerMsgAvailable;
            this.attrVal = resultMap.servicingBannerMsg;
          } else if (this.selectedAttr === Constants.SYS_ATTR_REVMORTBANNER) {
            this.selectedFlag = resultMap.isDeliveryServicingBannerMsgAvailable;
            this.attrVal = resultMap.deliveryServicingBannerMsg;
          } else if (this.selectedAttr === Constants.SYS_ATTR_DELIVBANNER) {
            this.selectedFlag = resultMap.isDeliveryBannerMsgAvailable;
            this.attrVal = resultMap.deliveryBannerMsg;
          }
          this.cdr.detectChanges();
        },
        error => {
          this.errorService.announceError(error);
        });

    // error announcement
    this.errorService.errorAnnouncedSource$.subscribe(
      message => {
        this.errorMsg = message;
        this.containsError = true;
        this.cdr.detectChanges();
      });
  }

  updateSystemAttributesLimit() {
    let attrName: string;
    this.showErrorDiv = false;
    this.successMess = false;
    this.userDetails = Constants.USER_DETAILS;
    let attrFlgName: string;
    if (this.attrVal.trim() === '') {
      this.showErrorDiv = true;
    } else {
      if (this.selectedAttr === Constants.SYS_ATTR_SYSBANNER) {
        attrName = 'systemAvailabilityMessage';
        attrFlgName = 'isSystemBannerMsgAvailable';
      } else if (this.selectedAttr === Constants.SYS_ATTR_SRVCBANNER) {
        attrName = 'servicingBannerMsg';
        attrFlgName = 'isServicingBannerMsgAvailable';
      } else if (this.selectedAttr === Constants.SYS_ATTR_REVMORTBANNER) {
        attrName = 'deliveryServicingBannerMsg';
        attrFlgName = 'isDeliveryServicingBannerMsgAvailable';
      } else if (this.selectedAttr === Constants.SYS_ATTR_DELIVBANNER) {
        attrName = 'deliveryBannerMsg';
        attrFlgName = 'isDeliveryBannerMsgAvailable';
      }
      const sysAttrWrapper: SysAttrWrapper = new SysAttrWrapper();
      const sysAttVal: SystemAttributesValue = new SystemAttributesValue();
      sysAttVal.attributeName = attrName;
      sysAttVal.attributeValue = this.attrVal;
      sysAttVal.lastUpdateUserID = sessionStorage.getItem('userID');;
      sysAttrWrapper.systemAttributesValue = sysAttVal;

      this.apiService.updateSysAttr(sysAttrWrapper).subscribe(
        (data: any) => {
          if (data === 1) {
            this.updateFlag(attrFlgName);
          } else {
            this.showErrorDiv = true;
          }
          this.cdr.detectChanges();
        },
        error => {
          this.errorService.announceError(error);
        });

      // error announcement
      this.errorService.errorAnnouncedSource$.subscribe(
        message => {
          this.errorMsg = message;
          this.containsError = true;
          this.cdr.detectChanges();
        });
    }
  }

  updateFlag(attrFlgName: string) {
    let sysAttrWrapper: SysAttrWrapper = new SysAttrWrapper();
    let sysAttVal: SystemAttributesValue = new SystemAttributesValue();
    sysAttrWrapper = new SysAttrWrapper();
    sysAttVal = new SystemAttributesValue();
    sysAttVal.attributeName = attrFlgName;
    sysAttVal.attributeValue = this.selectedFlag;
    sysAttVal.lastUpdateUserID = sessionStorage.getItem('userID');;
    sysAttrWrapper.systemAttributesValue = sysAttVal;

    this.apiService.updateSysAttr(sysAttrWrapper).subscribe((data: any) => {
      if (data === 1) {
        this.successMess = true;
      } else {
        this.showErrorDiv = true;
      }
      this.cdr.detectChanges();
    },
    error => {
      this.errorService.announceError(error);
    });
    // error announcement
    this.errorService.errorAnnouncedSource$.subscribe(
      message => {
        this.errorMsg = message;
        this.containsError = true;
        this.cdr.detectChanges();
      });
  }

  // Method for on key enter submit
  trackKeyPress(e) {
    console.log('KEY CODE  ', e.keyCode);
    if (e.keyCode === 13)
    {this.updateSystemAttributesLimit();}
  }

}

